export default __webpack_public_path__ + "static/media/_MG_0159.19eb7b18.JPG";